export default __webpack_public_path__ + "static/media/no-assignee.eb32f8fa.svg";